import React, { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { toast_Time_out } from "../../Utility/Constants";

function ToastMsg({ severity = "info", msg, msgPop, msgtop, rightside }) {
  const [open, setOpen] = useState(!!msg);
  const vertical = msgtop ? "top" : "bottom";
  const horizontal = msgtop ? "center" : rightside ? "right" : "left";

  useEffect(() => {
    setOpen(!!msg);
  }, [msg]);

  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
    msgPop?.();
  };

  if (!msg) return null;

  const text = typeof msg === "string" ? msg : "Something went wrong please try again";

  return (
    <Snackbar
      open={open}
      autoHideDuration={toast_Time_out}
      onClose={handleClose}
      anchorOrigin={{ vertical, horizontal }}
      action={
        <IconButton size="small" color="inherit" onClick={handleClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    >
      <Alert onClose={handleClose} severity={severity} variant="filled">
        {text}
      </Alert>
    </Snackbar>
  );
}

export default ToastMsg;
